import axios from "axios";


let apiClient = axios.create({
  baseURL: process.env.REACT_APP_MALBOX_BACKENDURL,
  headers: {
    'Content-Type': 'application/json'
  }
});

export default apiClient;
